import React from "react";
import { ROUTES } from "../constants/routes";
import { Navigate, Route, Routes } from "react-router-dom";
import MoneyWrapper from "../layout/money-wrapper";
import MoneyInvest from "../container/money/invest";
import MoneySpend from "../container/money/spend";
import MoneyProtect from "../container/money/protect";
import { WaitlistModalProvider } from "../components/money/context/waitlist-modal-context";
import TaxComponent from "../components/money/tax";
import FileITRPage from "../components/money/tax/file-itr";
import HRACalculator from "../components/money/tools/hra-calculator";

const MoneyRoutes = () => {
  return (
    <WaitlistModalProvider>
      <Routes>
        <Route element={<MoneyWrapper />}>
          <Route index element={<Navigate to={ROUTES.INVEST} replace />} />
          <Route path={ROUTES.INVEST} element={<MoneyInvest />} />
          <Route path={ROUTES.SPEND} element={<MoneySpend />} />
          <Route path={ROUTES.PROTECT} element={<MoneyProtect />} />
          <Route path={ROUTES.TAX} element={<TaxComponent />} />
          <Route path={ROUTES.FILE_ITR} element={<FileITRPage />} />
          <Route path={ROUTES.HRA} element={<HRACalculator />} />
        </Route>
      </Routes>
    </WaitlistModalProvider>
  );
};

export default MoneyRoutes;
